import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  LUMBER_WHOLESALERS_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from '../industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR } from '../industrySectorOptions';
import {
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const INDUSTRY_OPTIONS_ES = {
  [OILSEED_AND_GRAIN_INDUSTRY_GROUP]: [
    { value: '11111', label: 'Cultivo de soja' },
    { value: '11112', label: 'Cultivo de semillas oleaginosas (excepto soja)' },
    { value: '11113', label: 'Cultivo de guisantes secos y frijoles' },
    { value: '11114', label: 'Cultivo de trigo' },
    { value: '11115', label: 'Cultivo de maíz' },
    { value: '11116', label: 'Cultivo de arroz' },
    { value: '111191', label: 'Cultivo combinado de semillas oleaginosas y cereales' },
    { value: '111199', label: 'Otros cultivos de cereales' },
  ],

  [VEGETABLE_AND_MELON_INDUSTRY_GROUP]: [
    { value: '111211', label: 'Cultivo de patatas' },
    { value: '111219', label: 'Cultivo de otras hortalizas (excepto patatas) y melones' },
  ],

  [FRUIT_AND_TREE_NUT_INDUSTRY_GROUP]: [
    { value: '11131', label: 'Cultivo de naranjos' },
    { value: '11132', label: 'Cultivo de cítricos (excepto naranjos)' },
    { value: '111331', label: 'Cultivo de manzanos' },
    { value: '111332', label: 'Cultivo de viñedos' },
    { value: '111333', label: 'Cultivo de fresas' },
    { value: '111334', label: 'Cultivo de bayas (excepto fresas)' },
    { value: '111335', label: 'Cultivo de frutos secos de árbol' },
    { value: '111336', label: 'Cultivo combinado de frutas y frutos secos de árbol' },
    { value: '111339', label: 'Cultivo de otras frutas no cítricas' },
  ],

  [GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP]: [
    { value: '111411', label: 'Producción de hongos' },
    { value: '111419', label: 'Producción de otros cultivos alimentarios bajo cubierta' },
    { value: '111421', label: 'Producción de viveros y árboles' },
    { value: '111422', label: 'Producción de floricultura' },
  ],

  [OTHER_CROP_FARMING_INDUSTRY_GROUP]: [
    { value: '11191', label: 'Cultivo de tabaco' },
    { value: '11192', label: 'Cultivo de algodón' },
    { value: '11193', label: 'Cultivo de caña de azúcar' },
    { value: '11194', label: 'Cultivo de heno' },
    { value: '111991', label: 'Cultivo de remolacha azucarera' },
    { value: '111992', label: 'Cultivo de cacahuetes' },
    { value: '111998', label: 'Otros cultivos diversos' },
  ],

  [CATTLE_RANCHING_FARMING_INDUSTRY_GROUP]: [
    { value: '112111', label: 'Cría y explotación de ganado bovino para carne' },
    { value: '112112', label: 'Engorde de ganado bovino en corrales' },
    { value: '11212', label: 'Ganadería lechera y producción de leche' },
    { value: '11213', label: 'Cría y explotación de ganado bovino de doble propósito' },
  ],

  [HOD_AND_PIG_FARMING_INDUSTRY_GROUP]: [],

  [POULTRY_AND_EGG_INDUSTRY_GROUP]: [
    { value: '11231', label: 'Producción de huevos de gallina' },
    { value: '11232', label: 'Producción de pollos de engorde y otras aves para carne' },
    { value: '11233', label: 'Producción de pavos' },
    { value: '11233', label: 'Incubadoras avícolas' },
    { value: '11239', label: 'Otras actividades de producción avícola' },
  ],

  [SHEEP_AND_GOAT_INDUSTRY_GROUP]: [
    { value: '11241', label: 'Cría de ovejas' },
    { value: '11242', label: 'Cría de cabras' },
  ],

  [AQUACULTURE_INDUSTRY_GROUP]: [
    { value: '112511', label: 'Piscicultura e incubadoras de peces' },
    { value: '112512', label: 'Cultivo de mariscos' },
    { value: '112519', label: 'Otras actividades de acuicultura' },
  ],

  [OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '11291', label: 'Apicultura' },
    { value: '11292', label: 'Cría de caballos y otros équidos' },
    { value: '11293', label: 'Cría de animales de peletería y conejos' },
    { value: '11299', label: 'Otras actividades de producción animal' },
  ],

  [TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP]: [],

  [FOREST_NURSERIES_INDUSTRY_GROUP]: [],

  [LOGGING_INDUSTRY_GROUP]: [],

  [FISHING_INDUSTRY_GROUP]: [
    { value: '114111', label: 'Pesca de peces' },
    { value: '114112', label: 'Pesca de mariscos' },
    { value: '114119', label: 'Otras actividades de pesca marina' },
  ],

  [HUNTING_AND_TRAPPING_INDUSTRY_GROUP]: [],

  [SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP]: [
    { value: '115111', label: 'Desmotado de algodón' },
    { value: '115112', label: 'Preparación del suelo, siembra y cultivo' },
    { value: '115113', label: 'Cosecha de cultivos, principalmente mecanizada' },
    { value: '115114', label: 'Actividades posteriores a la cosecha (excepto desmotado de algodón)' },
    { value: '115115', label: 'Contratistas de mano de obra agrícola y jefes de cuadrilla' },
    { value: '115116', label: 'Servicios de gestión agrícola' },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [
    { value: '21112', label: 'Extracción de petróleo crudo' },
    { value: '21113', label: 'Extracción de gas natural' },
  ],

  [COAL_MINING_INDUSTRY_GROUP]: [
    { value: '212114', label: 'Minería de carbón a cielo abierto' },
    { value: '212115', label: 'Minería subterránea de carbón' },
  ],

  [METAL_ORE_MINING_INDUSTRY_GROUP]: [
    { value: '21221', label: 'Minería de mineral de hierro' },
    { value: '21222', label: 'Minería de minerales de oro y plata' },
    { value: '21223', label: 'Minería de cobre, níquel, plomo y zinc' },
    { value: '21229', label: 'Otra minería de minerales metálicos' },
  ],

  [NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP]: [
    { value: '212311', label: 'Extracción y explotación de piedra dimensional' },
    { value: '212312', label: 'Extracción y explotación de piedra caliza triturada y fragmentada' },
    { value: '212313', label: 'Extracción y explotación de granito triturado y fragmentado' },
    { value: '212319', label: 'Extracción y explotación de otras piedras trituradas y fragmentadas' },
    { value: '212321', label: 'Extracción de arena y grava para la construcción' },
    { value: '212322', label: 'Extracción de arena industrial' },
    { value: '212323', label: 'Extracción de caolín, arcilla y minerales cerámicos y refractarios' },
    { value: '21239', label: 'Otra minería y explotación de minerales no metálicos' },
  ],

  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    { value: '213111', label: 'Perforación de pozos de petróleo y gas' },
    { value: '213112', label: 'Servicios de apoyo para operaciones de petróleo y gas' },
    { value: '213113', label: 'Servicios de apoyo para la minería del carbón' },
    { value: '213114', label: 'Servicios de apoyo para la minería metálica' },
    {
      value: '213115',
      label: 'Servicios de apoyo para la extracción de minerales no metálicos (excepto combustibles)',
    },
  ],

  [ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP]: [
    { value: '221111', label: 'Generación de energía hidroeléctrica' },
    { value: '221112', label: 'Generación de energía eléctrica a partir de combustibles fósiles' },
    { value: '221113', label: 'Generación de energía nuclear' },
    { value: '221114', label: 'Generación de energía solar' },
    { value: '221115', label: 'Generación de energía eólica' },
    { value: '221116', label: 'Generación de energía geotérmica' },
    { value: '221117', label: 'Generación de energía a partir de biomasa' },
    { value: '221118', label: 'Otras actividades de generación de energía eléctrica' },
    { value: '221121', label: 'Transmisión y control de energía eléctrica a gran escala' },
    { value: '221122', label: 'Distribución de energía eléctrica' },
  ],

  [NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP]: [
    { value: '22131', label: 'Sistemas de suministro de agua y riego' },
    { value: '22132', label: 'Plantas de tratamiento de aguas residuales' },
    { value: '22133', label: 'Suministro de vapor y aire acondicionado' },
  ],

  [RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '236115', label: 'Construcción de nuevas viviendas unifamiliares (excepto promotores para venta)' },
    { value: '236116', label: 'Construcción de nuevas viviendas multifamiliares (excepto promotores para venta)' },
    { value: '236117', label: 'Promotores de viviendas nuevas para la venta' },
    { value: '236118', label: 'Remodelación de viviendas' },
  ],

  [NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23621', label: 'Construcción de edificios industriales' },
    { value: '23622', label: 'Construcción de edificios comerciales e institucionales' },
  ],

  [UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP]: [
    { value: '23711', label: 'Construcción de redes y estructuras relacionadas de agua y alcantarillado' },
    { value: '23712', label: 'Construcción de oleoductos, gasoductos y estructuras relacionadas' },
    { value: '23713', label: 'Construcción de líneas eléctricas, de comunicaciones y estructuras relacionadas' },
  ],

  [LAND_SUBDIVISION_INDUSTRY_GROUP]: [],

  [HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP]: [],

  [OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP]: [],

  [FOUNDATION_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23811', label: 'Contratistas de cimentaciones y estructuras de hormigón vertido' },
    { value: '23812', label: 'Contratistas de estructuras de acero y hormigón prefabricado' },
    { value: '23813', label: 'Contratistas de estructuras de entramado' },
    { value: '23814', label: 'Contratistas de albañilería' },
    { value: '23815', label: 'Contratistas de vidrio y acristalamiento' },
    { value: '23816', label: 'Contratistas de cubiertas y techos' },
    { value: '23817', label: 'Contratistas de revestimientos exteriores' },
    { value: '23819', label: 'Otros contratistas de cimentaciones, estructuras y exteriores de edificios' },
  ],

  [BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23821', label: 'Contratistas eléctricos y de otras instalaciones de cableado' },
    { value: '23822', label: 'Contratistas de fontanería, calefacción y aire acondicionado' },
    { value: '23829', label: 'Otros contratistas de instalaciones para edificios' },
  ],

  [BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP]: [
    { value: '23831', label: 'Contratistas de paneles de yeso y aislamiento' },
    { value: '23832', label: 'Contratistas de pintura y revestimientos murales' },
    { value: '23833', label: 'Contratistas de revestimientos para suelos' },
    { value: '23834', label: 'Contratistas de baldosas y terrazo' },
    { value: '23835', label: 'Contratistas de carpintería de acabado' },
    { value: '23839', label: 'Otros contratistas de acabados para edificios' },
  ],

  [OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP]: [
    { value: '23891', label: 'Contratistas de preparación de terrenos' },
    { value: '23899', label: 'Otros contratistas especializados' },
  ],

  [ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311111', label: 'Fabricación de alimentos para perros y gatos' },
    { value: '311119', label: 'Fabricación de otros alimentos para animales' },
  ],

  [GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP]: [
    { value: '311211', label: 'Molienda de harina' },
    { value: '311212', label: 'Molienda de arroz' },
    { value: '311213', label: 'Fabricación de malta' },
    { value: '311221', label: 'Molienda húmeda de maíz y fabricación de almidón' },
    { value: '311224', label: 'Procesamiento de soja y otras semillas oleaginosas' },
    { value: '311224', label: 'Refinado y mezcla de grasas y aceites' },
    { value: '31123', label: 'Fabricación de cereales para el desayuno' },
  ],

  [SUGAR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311313', label: 'Fabricación de azúcar de remolacha' },
    { value: '311314', label: 'Fabricación de azúcar de caña' },
    { value: '31134', label: 'Fabricación de confitería sin chocolate' },
    { value: '31135', label: 'Fabricación de chocolate y productos de confitería' },
  ],

  [FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311411', label: 'Fabricación de frutas, jugos y verduras congelados' },
    { value: '311412', label: 'Fabricación de alimentos congelados especializados' },
    { value: '311421', label: 'Conservación de frutas y verduras' },
    { value: '311422', label: 'Conservas especializadas' },
    { value: '311423', label: 'Fabricación de alimentos deshidratados y secos' },
  ],

  [DAIRY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311511', label: 'Fabricación de leche líquida' },
    { value: '311512', label: 'Fabricación de mantequilla' },
    { value: '311513', label: 'Fabricación de queso' },
    { value: '311514', label: 'Fabricación de productos lácteos secos, condensados y evaporados' },
    { value: '31152', label: 'Fabricación de helados y postres congelados' },
  ],

  [ANIMAL_SLAUGHTERING_INDUSTRY_GROUP]: [
    { value: '311611', label: 'Sacrificio de animales (excepto aves de corral)' },
    { value: '311612', label: 'Procesamiento de carne procedente de canales' },
    { value: '311613', label: 'Procesamiento de subproductos cárnicos y rendering' },
    { value: '311615', label: 'Procesamiento de aves de corral' },
  ],

  [SEAFOOD_PREPARATION_INDUSTRY_GROUP]: [],

  [BAKERIES_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311811', label: 'Panaderías minoristas' },
    { value: '311812', label: 'Panaderías comerciales' },
    { value: '311813', label: 'Fabricación de pasteles, tartas y otros productos de repostería congelados' },
    { value: '311821', label: 'Fabricación de galletas y crackers' },
    { value: '311824', label: 'Fabricación de pasta seca, masas y mezclas de harina a partir de harina adquirida' },
    { value: '31183', label: 'Fabricación de tortillas' },
  ],

  [OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '311911', label: 'Fabricación de frutos secos tostados y mantequilla de cacahuete' },
    { value: '311919', label: 'Fabricación de otros aperitivos' },
    { value: '31192', label: 'Fabricación de café y té' },
    { value: '31193', label: 'Fabricación de siropes concentrados y aromatizantes' },
    { value: '311941', label: 'Fabricación de mayonesa, aderezos y otras salsas preparadas' },
    { value: '311942', label: 'Fabricación de especias y extractos' },
    { value: '31199', label: 'Otras actividades de fabricación de alimentos' },
  ],

  [BEVERAGE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '312111', label: 'Fabricación de refrescos' },
    { value: '312112', label: 'Fabricación de agua embotellada' },
    { value: '312113', label: 'Fabricación de hielo' },
    { value: '31212', label: 'Cervecerías' },
    { value: '31213', label: 'Bodegas' },
    { value: '31214', label: 'Destilerías' },
  ],

  [TOBACCO_MANUFACTURING_INDUSTRY_GROUP]: [],

  [FIBER_YARN_MILLS_INDUSTRY_GROUP]: [],

  [FABRIC_MILLS_INDUSTRY_GROUP]: [
    { value: '31321', label: 'Fabricación de tejidos anchos' },
    { value: '31322', label: 'Fabricación de tejidos estrechos y bordado mecánico Schiffli' },
    { value: '31323', label: 'Fabricación de tejidos no tejidos' },
    { value: '31324', label: 'Fabricación de tejidos de punto' },
  ],

  [TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31331', label: 'Acabado de textiles y tejidos' },
    { value: '31332', label: 'Recubrimiento de tejidos' },
  ],

  [TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP]: [
    { value: '31411', label: 'Fabricación de alfombras y moquetas' },
    { value: '31412', label: 'Fabricación de cortinas y ropa de hogar' },
  ],

  [OTHER_TEXTILE_MILLS_INDUSTRY_GROUP]: [
    { value: '31491', label: 'Fabricación de sacos textiles y lonas' },
    {
      value: '314994',
      label: 'Fabricación de cuerdas, cordeles, bramantes, cordones para neumáticos y tejidos para neumáticos',
    },
    { value: '314999', label: 'Fabricación de otros productos textiles diversos' },
  ],

  [APPAREL_KNITTING_MILLS_INDUSTRY_GROUP]: [],

  [CUT_AND_SEW_APPAREL_INDUSTRY_GROUP]: [
    { value: '31521', label: 'Contratistas de confección de prendas de vestir' },
    { value: '31525', label: 'Fabricación de prendas de vestir confeccionadas (excepto contratistas)' },
  ],

  [APPAREL_ACCESSORIES_INDUSTRY_GROUP]: [],

  [LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP]: [],

  [FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP]: [],

  [OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP]: [],

  [SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP]: [
    { value: '321113', label: 'Aserraderos' },
    { value: '321114', label: 'Preservación de la madera' },
  ],

  [VENEER_PLYWOOD_INDUSTRY_GROUP]: [
    { value: '321211', label: 'Fabricación de chapas y madera contrachapada de frondosas' },
    { value: '321212', label: 'Fabricación de chapas y madera contrachapada de coníferas' },
    { value: '321215', label: 'Fabricación de componentes estructurales de madera de ingeniería' },
    { value: '321219', label: 'Fabricación de productos de madera reconstituida' },
  ],

  [OTHER_WOOD_PRODUCT_INDUSTRY_GROUP]: [
    { value: '321911', label: 'Fabricación de ventanas y puertas de madera' },
    { value: '321912', label: 'Corte, reaserrado, cepillado y preparación de madera' },
    { value: '321918', label: 'Otros productos de carpintería (incluidos los suelos)' },
    { value: '32192', label: 'Fabricación de contenedores y palés de madera' },
    { value: '321991', label: 'Fabricación de viviendas prefabricadas (casas móviles)' },
    { value: '321992', label: 'Fabricación de edificios prefabricados de madera' },
    { value: '321999', label: 'Fabricación de otros productos diversos de madera' },
  ],

  [PULP_PAPER_MILLS_INDUSTRY_GROUP]: [
    { value: '32211', label: 'Fabricación de pasta de papel' },
    { value: '32212', label: 'Fabricación de papel' },
    { value: '32213', label: 'Fabricación de cartón' },
  ],

  [CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32221', label: 'Fabricación de envases de cartón' },
    { value: '32222', label: 'Fabricación de bolsas de papel y de papel revestido y tratado' },
    { value: '32223', label: 'Fabricación de artículos de papelería' },
    { value: '322291', label: 'Fabricación de productos sanitarios de papel' },
    { value: '322299', label: 'Fabricación de otros productos transformados de papel' },
  ],

  [BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32511', label: 'Fabricación de productos petroquímicos' },
    { value: '32512', label: 'Fabricación de gases industriales' },
    { value: '32513', label: 'Fabricación de colorantes y pigmentos sintéticos' },
    { value: '32518', label: 'Fabricación de otros productos químicos inorgánicos básicos' },
    { value: '325193', label: 'Fabricación de alcohol etílico' },
    {
      value: '325194',
      label: 'Fabricación de productos químicos derivados de crudos cíclicos, intermedios, gomas y madera',
    },
    { value: '325199', label: 'Fabricación de otros productos químicos orgánicos básicos' },
  ],

  [RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325211', label: 'Fabricación de resinas y materiales plásticos' },
    { value: '325212', label: 'Fabricación de caucho sintético' },
    { value: '32522', label: 'Fabricación de fibras y filamentos artificiales y sintéticos' },
  ],

  [PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325311', label: 'Fabricación de fertilizantes nitrogenados' },
    { value: '325312', label: 'Fabricación de fertilizantes fosfatados' },
    { value: '325314', label: 'Fabricación de fertilizantes (solo mezcla)' },
    { value: '325315', label: 'Fabricación de compost' },
    { value: '32532', label: 'Fabricación de pesticidas y otros productos químicos agrícolas' },
  ],

  [PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325411', label: 'Fabricación de productos medicinales y botánicos' },
    { value: '325412', label: 'Fabricación de preparados farmacéuticos' },
    { value: '325413', label: 'Fabricación de sustancias para diagnóstico in vitro' },
    { value: '325414', label: 'Fabricación de productos biológicos (excepto para diagnóstico)' },
  ],

  [PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32551', label: 'Fabricación de pinturas y recubrimientos' },
    { value: '32552', label: 'Fabricación de adhesivos' },
  ],

  [SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '325611', label: 'Fabricación de jabones y otros detergentes' },
    { value: '325612', label: 'Fabricación de productos de limpieza y saneamiento' },
    { value: '325613', label: 'Fabricación de agentes tensioactivos' },
    { value: '32562', label: 'Fabricación de productos de higiene personal' },
  ],

  [OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32591', label: 'Fabricación de tintas de impresión' },
    { value: '32592', label: 'Fabricación de explosivos' },
    { value: '325991', label: 'Mezcla personalizada de resinas adquiridas' },
    {
      value: '325992',
      label: 'Fabricación de películas, papel, placas, productos químicos fotográficos y tóner para copiadoras',
    },
    { value: '325998', label: 'Fabricación de otros productos y preparados químicos diversos' },
  ],

  [PLASTIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326111', label: 'Fabricación de bolsas y fundas de plástico' },
    { value: '326112', label: 'Fabricación de películas y láminas plásticas para envases (incluidos los laminados)' },
    { value: '326113', label: 'Fabricación de películas y láminas plásticas no laminadas (excepto para envases)' },
    { value: '326121', label: 'Fabricación de perfiles plásticos no laminados' },
    { value: '326122', label: 'Fabricación de tuberías y accesorios de tuberías de plástico' },
    { value: '32613', label: 'Fabricación de placas, láminas y perfiles plásticos laminados (excepto para envases)' },
    { value: '32614', label: 'Fabricación de productos de espuma de poliestireno' },
    { value: '32615', label: 'Fabricación de productos de espuma de uretano y otras espumas (excepto poliestireno)' },
    { value: '32616', label: 'Fabricación de botellas de plástico' },
    { value: '326191', label: 'Fabricación de accesorios sanitarios de plástico' },
    { value: '326199', label: 'Fabricación de otros productos de plástico' },
  ],

  [RUBBER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '326211', label: 'Fabricación de neumáticos (excepto recauchutado)' },
    { value: '326212', label: 'Recauchutado de neumáticos' },
    { value: '32622', label: 'Fabricación de mangueras y correas de caucho y plástico' },
    { value: '326291', label: 'Fabricación de productos de caucho para uso mecánico' },
    { value: '326299', label: 'Fabricación de otros productos de caucho' },
  ],

  [CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32711', label: 'Fabricación de cerámica, alfarería y accesorios sanitarios' },
    { value: '32712', label: 'Fabricación de materiales de construcción de arcilla y productos refractarios' },
  ],

  [GLASS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '327211', label: 'Fabricación de vidrio plano' },
    { value: '327212', label: 'Fabricación de otros artículos de vidrio prensado, soplado y cristalería' },
    { value: '327213', label: 'Fabricación de envases de vidrio' },
    { value: '327215', label: 'Fabricación de productos de vidrio a partir de vidrio adquirido' },
  ],

  [CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32731', label: 'Fabricación de cemento' },
    { value: '32732', label: 'Fabricación de hormigón premezclado' },
    { value: '327331', label: 'Fabricación de bloques y ladrillos de hormigón' },
    { value: '327332', label: 'Fabricación de tuberías de hormigón' },
    { value: '32739', label: 'Fabricación de otros productos de hormigón' },
  ],

  [LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32741', label: 'Fabricación de cal' },
    { value: '32742', label: 'Fabricación de productos de yeso' },
  ],

  [OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '32791', label: 'Fabricación de productos abrasivos' },
    { value: '327991', label: 'Fabricación de piedra cortada y productos de piedra' },
    { value: '327992', label: 'Fabricación de minerales y tierras molidos o tratados' },
    { value: '327993', label: 'Fabricación de lana mineral' },
    { value: '327999', label: 'Fabricación de otros productos minerales no metálicos diversos' },
  ],

  [IRON_AND_STEEL_MILLS_INDUSTRY_GROUP]: [],

  [STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33121', label: 'Fabricación de tubos y tuberías de hierro y acero a partir de acero adquirido' },
    { value: '331221', label: 'Fabricación de perfiles laminados de acero' },
    { value: '331222', label: 'Trefilado de acero' },
  ],

  [ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '331313', label: 'Refinado de alúmina y producción primaria de aluminio' },
    { value: '331314', label: 'Fundición secundaria y aleación de aluminio' },
    { value: '331315', label: 'Fabricación de láminas, placas y hojas de aluminio' },
    { value: '331318', label: 'Otros procesos de laminado, trefilado y extrusión de aluminio' },
  ],

  [NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP]: [
    { value: '33141', label: 'Fundición y refinado de metales no ferrosos (excepto aluminio)' },
    { value: '33142', label: 'Laminado, trefilado, extrusión y aleación de cobre' },
    { value: '331491', label: 'Laminado, trefilado y extrusión de metales no ferrosos (excepto cobre y aluminio)' },
    {
      value: '331492',
      label: 'Fundición secundaria, refinado y aleación de metales no ferrosos (excepto cobre y aluminio)',
    },
  ],

  [FOUNDRIES_INDUSTRY_GROUP]: [
    { value: '331511', label: 'Fundiciones de hierro' },
    { value: '331512', label: 'Fundiciones de acero de precisión' },
    { value: '331513', label: 'Fundiciones de acero (excepto de precisión)' },
    { value: '331523', label: 'Fundiciones de metales no ferrosos por fundición a presión' },
    { value: '331524', label: 'Fundiciones de aluminio (excepto fundición a presión)' },
    { value: '331529', label: 'Otras fundiciones de metales no ferrosos (excepto fundición a presión)' },
  ],

  [FORGING_AND_STAMPING_INDUSTRY_GROUP]: [
    { value: '332111', label: 'Forja de hierro y acero' },
    { value: '332112', label: 'Forja de metales no ferrosos' },
    { value: '332114', label: 'Perfilado personalizado por rodillos' },
    { value: '332117', label: 'Fabricación de piezas mediante pulvimetalurgia' },
    {
      value: '332119',
      label:
        'Fabricación de tapas metálicas, cierres y otros productos estampados de metal (excepto para la industria automotriz)',
    },
  ],

  [CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '332215',
      label:
        'Fabricación de utensilios de cocina, cubiertos y artículos de mesa metálicos (excepto de metales preciosos)',
    },
    { value: '332216', label: 'Fabricación de hojas de sierra y herramientas manuales' },
  ],

  [ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332311', label: 'Fabricación de edificios metálicos prefabricados y sus componentes' },
    { value: '332312', label: 'Fabricación de estructuras metálicas' },
    { value: '332313', label: 'Fabricación de estructuras de chapa metálica' },
    { value: '332321', label: 'Fabricación de ventanas y puertas metálicas' },
    { value: '332322', label: 'Fabricación de trabajos en chapa metálica' },
    { value: '332323', label: 'Fabricación de elementos metálicos ornamentales y arquitectónicos' },
  ],

  [BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33241', label: 'Fabricación de calderas industriales e intercambiadores de calor' },
    { value: '33242', label: 'Fabricación de tanques metálicos de gran espesor' },
    { value: '332431', label: 'Fabricación de latas metálicas' },
    { value: '332439', label: 'Fabricación de otros recipientes metálicos' },
  ],

  [HARDWARE_MANUFACTURING_INDUSTRY_GROUP]: [],

  [SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332613', label: 'Fabricación de resortes' },
    { value: '332618', label: 'Fabricación de otros productos de alambre' },
  ],

  [MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33271', label: 'Talleres de mecanizado' },
    { value: '332721', label: 'Fabricación de productos torneados de precisión' },
    { value: '332722', label: 'Fabricación de pernos, tuercas, tornillos, remaches y arandelas' },
  ],

  [COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP]: [
    { value: '332811', label: 'Tratamiento térmico de metales' },
    {
      value: '332812',
      label: 'Recubrimiento, grabado (excepto joyería y platería) y servicios relacionados para fabricantes',
    },
    {
      value: '332813',
      label: 'Galvanizado, recubrimiento, pulido, anodizado y coloreado de metales',
    },
  ],

  [OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '332911', label: 'Fabricación de válvulas industriales' },
    { value: '332912', label: 'Fabricación de válvulas hidráulicas y conexiones para mangueras' },
    { value: '332913', label: 'Fabricación de accesorios y acabados para instalaciones de fontanería' },
    { value: '332919', label: 'Fabricación de otras válvulas y accesorios para tuberías metálicas' },
    { value: '332991', label: 'Fabricación de rodamientos de bolas y rodillos' },
    { value: '332992', label: 'Fabricación de munición para armas ligeras' },
    { value: '332993', label: 'Fabricación de munición (excepto para armas ligeras)' },
    { value: '332994', label: 'Fabricación de armas ligeras, artillería y accesorios de armamento' },
    { value: '332996', label: 'Fabricación de tuberías y accesorios de tuberías fabricados' },
    { value: '332999', label: 'Fabricación de otros productos metálicos diversos' },
  ],

  [AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333111', label: 'Fabricación de maquinaria y equipos agrícolas' },
    { value: '333112', label: 'Fabricación de tractores para césped y jardín, y equipos para el hogar y jardinería' },
    { value: '33312', label: 'Fabricación de maquinaria para la construcción' },
    { value: '333131', label: 'Fabricación de maquinaria y equipos para minería' },
    { value: '333132', label: 'Fabricación de maquinaria y equipos para yacimientos de petróleo y gas' },
  ],

  [INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333241', label: 'Fabricación de maquinaria para la industria alimentaria' },
    { value: '333242', label: 'Fabricación de maquinaria para semiconductores' },
    { value: '333243', label: 'Fabricación de maquinaria para aserraderos, carpintería y la industria del papel' },
    { value: '333248', label: 'Fabricación de otra maquinaria industrial' },
  ],

  [COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP]: [],

  [VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP]: [
    {
      value: '333413',
      label: 'Fabricación de ventiladores industriales y comerciales, sopladores y equipos de purificación de aire',
    },
    {
      value: '333414',
      label: 'Fabricación de equipos de calefacción (excepto hornos de aire caliente)',
    },
    {
      value: '333415',
      label:
        'Fabricación de equipos de aire acondicionado, calefacción por aire caliente y refrigeración comercial e industrial',
    },
  ],

  [METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333511', label: 'Fabricación de moldes industriales' },
    {
      value: '333514',
      label: 'Fabricación de troqueles especiales, juegos de troqueles, plantillas y dispositivos de sujeción',
    },
    {
      value: '333515',
      label: 'Fabricación de herramientas de corte y accesorios para máquinas herramienta',
    },
    { value: '333517', label: 'Fabricación de máquinas herramienta' },
    {
      value: '333519',
      label: 'Fabricación de trenes de laminación y otra maquinaria para el trabajo de metales',
    },
  ],

  [ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '333611', label: 'Fabricación de turbinas y grupos electrógenos de turbina' },
    {
      value: '333612',
      label: 'Fabricación de variadores de velocidad, transmisiones industriales de alta velocidad y engranajes',
    },
    {
      value: '333613',
      label: 'Fabricación de equipos de transmisión mecánica de potencia',
    },
    { value: '333618', label: 'Fabricación de otros equipos para motores' },
  ],

  [OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33391', label: 'Fabricación de bombas y compresores' },
    { value: '333912', label: 'Fabricación de compresores de aire y gas' },
    {
      value: '333914',
      label: 'Fabricación de equipos de bombeo, dosificación y medición, y otros equipos de bombeo',
    },
    { value: '333921', label: 'Fabricación de ascensores y escaleras mecánicas' },
    { value: '333922', label: 'Fabricación de transportadores y equipos de transporte continuo' },
    {
      value: '333923',
      label: 'Fabricación de grúas puente, polipastos y sistemas de monorraíl',
    },
    {
      value: '333924',
      label: 'Fabricación de carretillas industriales, tractores, remolques y maquinaria apiladora',
    },
    { value: '333991', label: 'Fabricación de herramientas eléctricas portátiles' },
    { value: '333992', label: 'Fabricación de equipos de soldadura y soldadura fuerte' },
    { value: '333993', label: 'Fabricación de maquinaria de envasado' },
    { value: '333994', label: 'Fabricación de hornos y estufas para procesos industriales' },
    { value: '333995', label: 'Fabricación de cilindros y actuadores hidráulicos y neumáticos' },
    { value: '333996', label: 'Fabricación de bombas y motores hidráulicos y neumáticos' },
    { value: '333998', label: 'Fabricación de otra maquinaria de uso general' },
  ],

  [COMPUTER_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334111', label: 'Fabricación de computadoras electrónicas' },
    { value: '334112', label: 'Fabricación de dispositivos de almacenamiento informático' },
    { value: '334118', label: 'Fabricación de terminales informáticos y otros equipos periféricos' },
  ],

  [COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33421', label: 'Fabricación de equipos telefónicos' },
    { value: '33422', label: 'Fabricación de equipos de radiodifusión, televisión y comunicaciones inalámbricas' },
    { value: '33429', label: 'Fabricación de otros equipos de comunicaciones' },
  ],

  [AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP]: [],

  [SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '334412', label: 'Fabricación de placas de circuito impreso sin componentes' },
    { value: '334413', label: 'Fabricación de semiconductores y dispositivos relacionados' },
    {
      value: '334416',
      label: 'Fabricación de condensadores, resistencias, bobinas, transformadores y otros inductores',
    },
    { value: '334417', label: 'Fabricación de conectores electrónicos' },
    { value: '334418', label: 'Fabricación de conjuntos de circuitos impresos (ensamblajes electrónicos)' },
    { value: '334419', label: 'Fabricación de otros componentes electrónicos' },
  ],

  [NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP]: [
    { value: '334510', label: 'Fabricación de equipos electromédicos y electroterapéuticos' },
    {
      value: '334511',
      label: 'Fabricación de sistemas e instrumentos de búsqueda, detección, navegación, guiado, aeronáutica y náutica',
    },
    {
      value: '334512',
      label:
        'Fabricación de sistemas automáticos de control ambiental para uso residencial, comercial y de electrodomésticos',
    },
    {
      value: '334513',
      label:
        'Fabricación de instrumentos y productos relacionados para medir, visualizar y controlar variables de procesos industriales',
    },
    { value: '334514', label: 'Fabricación de medidores totalizadores de fluidos y dispositivos contadores' },
    { value: '334515', label: 'Fabricación de instrumentos para medir y probar electricidad y señales eléctricas' },
    { value: '334516', label: 'Fabricación de instrumentos analíticos de laboratorio' },
    { value: '334517', label: 'Fabricación de equipos de irradiación' },
    { value: '334519', label: 'Fabricación de otros dispositivos de medición y control' },
  ],

  [MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP]: [],

  [ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '335131', label: 'Fabricación de luminarias eléctricas residenciales' },
    { value: '335132', label: 'Fabricación de luminarias eléctricas comerciales, industriales e institucionales' },
    { value: '335139', label: 'Fabricación de bombillas eléctricas y otros equipos de iluminación' },
  ],

  [HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33521', label: 'Fabricación de pequeños electrodomésticos' },
    { value: '33522', label: 'Fabricación de grandes electrodomésticos' },
  ],

  [ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '335311', label: 'Fabricación de transformadores de potencia, distribución y uso especializado' },
    { value: '335312', label: 'Fabricación de motores y generadores eléctricos' },
    { value: '335313', label: 'Fabricación de equipos de conmutación y cuadros eléctricos' },
    { value: '335314', label: 'Fabricación de relés y equipos de control industrial' },
  ],

  [OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33591', label: 'Fabricación de baterías' },
    { value: '335921', label: 'Fabricación de cables de fibra óptica' },
    { value: '335929', label: 'Fabricación de otros cables para comunicaciones y energía' },
    { value: '33593', label: 'Fabricación de dispositivos de cableado eléctrico' },
    { value: '335991', label: 'Fabricación de productos de carbono y grafito' },
    { value: '335999', label: 'Fabricación de otros equipos y componentes eléctricos diversos' },
  ],

  [MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33611', label: 'Fabricación de automóviles y vehículos ligeros' },
    { value: '33612', label: 'Fabricación de camiones pesados' },
  ],

  [VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336211', label: 'Fabricación de carrocerías para vehículos de motor' },
    { value: '336212', label: 'Fabricación de remolques para camiones' },
    { value: '336213', label: 'Fabricación de autocaravanas' },
    { value: '336214', label: 'Fabricación de caravanas y remolques camper' },
  ],

  [VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33631', label: 'Fabricación de motores de gasolina y piezas para vehículos de motor' },
    { value: '33632', label: 'Fabricación de equipos eléctricos y electrónicos para vehículos de motor' },
    {
      value: '33633',
      label: 'Fabricación de componentes de dirección y suspensión para vehículos de motor (excepto muelles)',
    },
    { value: '33634', label: 'Fabricación de sistemas de frenos para vehículos de motor' },
    { value: '33635', label: 'Fabricación de transmisiones y componentes del tren motriz para vehículos de motor' },
    { value: '33636', label: 'Fabricación de asientos y acabados interiores para vehículos de motor' },
    { value: '33637', label: 'Estampado de metales para vehículos de motor' },
    { value: '33639', label: 'Fabricación de otras piezas para vehículos de motor' },
  ],

  [AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336411', label: 'Fabricación de aeronaves' },
    { value: '336412', label: 'Fabricación de motores y componentes para aeronaves' },
    { value: '336413', label: 'Fabricación de otras piezas y equipos auxiliares para aeronaves' },
    { value: '336414', label: 'Fabricación de misiles guiados y vehículos espaciales' },
    {
      value: '336415',
      label: 'Fabricación de unidades de propulsión y componentes para misiles guiados y vehículos espaciales',
    },
    {
      value: '336419',
      label: 'Fabricación de otras piezas y equipos auxiliares para misiles guiados y vehículos espaciales',
    },
  ],

  [RAILROAD_MANUFACTURING_INDUSTRY_GROUP]: [],

  [SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP]: [
    { value: '336611', label: 'Construcción y reparación de buques' },
    { value: '336612', label: 'Construcción de embarcaciones' },
  ],

  [OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '336991', label: 'Fabricación de motocicletas, bicicletas y sus componentes' },
    { value: '336992', label: 'Fabricación de vehículos blindados militares, tanques y sus componentes' },
    { value: '336999', label: 'Fabricación de otros equipos de transporte' },
  ],
  [HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33711', label: 'Fabricación de armarios de cocina y encimeras de madera' },
    { value: '337121', label: 'Fabricación de muebles tapizados para el hogar' },
    { value: '337122', label: 'Fabricación de muebles de madera para el hogar sin tapizar' },
    { value: '337126', label: 'Fabricación de muebles para el hogar (excepto de madera y tapizados)' },
    { value: '337127', label: 'Fabricación de mobiliario institucional' },
  ],

  [OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '337211', label: 'Fabricación de muebles de oficina de madera' },
    { value: '337212', label: 'Fabricación de carpintería arquitectónica y ebanistería a medida' },
    { value: '337214', label: 'Fabricación de muebles de oficina (excepto de madera)' },
    { value: '337215', label: 'Fabricación de vitrinas, mamparas, estanterías y taquillas' },
  ],

  [OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33791', label: 'Fabricación de colchones' },
    { value: '33792', label: 'Fabricación de persianas y cortinas enrollables' },
  ],

  [MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '339112', label: 'Fabricación de instrumentos quirúrgicos y médicos' },
    { value: '339113', label: 'Fabricación de aparatos y suministros quirúrgicos' },
    { value: '339114', label: 'Fabricación de equipos y suministros dentales' },
    { value: '339115', label: 'Fabricación de productos oftálmicos' },
    { value: '339116', label: 'Laboratorios dentales' },
  ],

  [OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP]: [
    { value: '33991', label: 'Fabricación de joyería y artículos de platería' },
    { value: '33992', label: 'Fabricación de artículos deportivos y de atletismo' },
    { value: '33993', label: 'Fabricación de muñecas, juguetes y juegos' },
    { value: '33994', label: 'Fabricación de material de oficina (excepto productos de papel)' },
    { value: '33995', label: 'Fabricación de rótulos y señalización' },
    { value: '339991', label: 'Fabricación de juntas, empaques y dispositivos de sellado' },
    { value: '339992', label: 'Fabricación de instrumentos musicales' },
    { value: '339993', label: 'Fabricación de sujetadores, botones, agujas y alfileres' },
    { value: '339994', label: 'Fabricación de escobas, cepillos y fregonas' },
    { value: '339995', label: 'Fabricación de ataúdes' },
    { value: '339999', label: 'Fabricación de otros productos diversos' },
  ],

  [PRINTING_MANUFACTURING_SUB_SECTOR]: [
    { value: '323111', label: 'Impresión comercial (excepto serigrafía y libros)' },
    { value: '323113', label: 'Serigrafía comercial' },
    { value: '323117', label: 'Impresión de libros' },
    { value: '32312', label: 'Servicios de apoyo para la impresión' },
  ],

  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [
    { value: '32411', label: 'Refinerías de petróleo' },
    { value: '324121', label: 'Fabricación de mezclas asfálticas para pavimentación y bloques de asfalto' },
    { value: '324122', label: 'Fabricación de tejas asfálticas y materiales de revestimiento asfálticos' },
    { value: '324191', label: 'Fabricación de aceites lubricantes y grasas derivadas del petróleo' },
    { value: '324199', label: 'Fabricación de otros productos derivados del petróleo y del carbón' },
  ],

  [MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42311', label: 'Mayoristas de automóviles y otros vehículos de motor' },
    { value: '42312', label: 'Mayoristas de suministros y repuestos nuevos para vehículos de motor' },
    { value: '42313', label: 'Mayoristas de neumáticos y cámaras' },
    { value: '42314', label: 'Mayoristas de piezas usadas para vehículos de motor' },
  ],

  [FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42321', label: 'Mayoristas de muebles' },
    { value: '42322', label: 'Mayoristas de artículos para el hogar' },
  ],

  [LUMBER_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42331', label: 'Mayoristas de madera, contrachapado, carpintería y paneles de madera' },
    { value: '42332', label: 'Mayoristas de ladrillos, piedra y materiales de construcción relacionados' },
    { value: '42333', label: 'Mayoristas de materiales para cubiertas, revestimientos y aislamiento' },
    { value: '42339', label: 'Mayoristas de otros materiales de construcción' },
  ],

  [PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42341', label: 'Mayoristas de equipos y suministros fotográficos' },
    { value: '42342', label: 'Mayoristas de equipos de oficina' },
    { value: '42343', label: 'Mayoristas de computadoras, equipos periféricos y software' },
    { value: '42344', label: 'Mayoristas de otros equipos comerciales' },
    { value: '42345', label: 'Mayoristas de equipos y suministros médicos, dentales y hospitalarios' },
    { value: '42346', label: 'Mayoristas de productos oftálmicos' },
    { value: '42349', label: 'Mayoristas de otros equipos y suministros profesionales' },
  ],

  [METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42351', label: 'Centros de servicio de metales y otros mayoristas de metales' },
    { value: '42352', label: 'Mayoristas de carbón, minerales y menas' },
  ],

  [HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42361',
      label: 'Mayoristas de equipos eléctricos, materiales de cableado y equipos relacionados',
    },
    {
      value: '42362',
      label: 'Mayoristas de electrodomésticos, pequeños aparatos eléctricos y electrónica de consumo',
    },
    { value: '42369', label: 'Mayoristas de otros componentes y equipos electrónicos' },
  ],

  [HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42371', label: 'Mayoristas de ferretería' },
    { value: '42372', label: 'Mayoristas de equipos y suministros de fontanería y calefacción (hidrónica)' },
    {
      value: '42373',
      label: 'Mayoristas de equipos y suministros de calefacción por aire caliente y aire acondicionado',
    },
    { value: '42374', label: 'Mayoristas de equipos y suministros de refrigeración' },
  ],

  [MACHINERY_WHOLESALERS_INDUSTRY_GROUP]: [
    {
      value: '42381',
      label: 'Mayoristas de maquinaria y equipos para construcción y minería (excepto equipos para pozos petroleros)',
    },
    { value: '42382', label: 'Mayoristas de maquinaria y equipos agrícolas y de jardinería' },
    { value: '42383', label: 'Mayoristas de maquinaria y equipos industriales' },
    { value: '42384', label: 'Mayoristas de suministros industriales' },
    { value: '42385', label: 'Mayoristas de equipos y suministros para establecimientos de servicios' },
    {
      value: '42386',
      label: 'Mayoristas de equipos y suministros para transporte (excepto vehículos de motor)',
    },
  ],

  [MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42391', label: 'Mayoristas de artículos y suministros deportivos y recreativos' },
    { value: '42392', label: 'Mayoristas de juguetes, artículos de hobby y suministros relacionados' },
    { value: '42393', label: 'Mayoristas de materiales reciclables' },
    { value: '42394', label: 'Mayoristas de joyería, relojes, piedras preciosas y metales preciosos' },
    { value: '42399', label: 'Mayoristas de otros bienes duraderos diversos' },
  ],

  [PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42411', label: 'Mayoristas de papel para impresión y escritura' },
    { value: '42412', label: 'Mayoristas de papelería y suministros de oficina' },
    { value: '42413', label: 'Mayoristas de papel para uso industrial y servicios personales' },
  ],

  [DRUGS_WHOLESALERS_INDUSTRY_GROUP]: [],

  [APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42431', label: 'Mayoristas de tejidos, mercería y otros artículos textiles' },
    { value: '42434', label: 'Mayoristas de calzado' },
    { value: '42435', label: 'Mayoristas de ropa y accesorios de vestir' },
  ],

  [GROCERY_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42441', label: 'Mayoristas de productos alimenticios generales' },
    { value: '42442', label: 'Mayoristas de alimentos congelados envasados' },
    { value: '42443', label: 'Mayoristas de productos lácteos (excepto secos o enlatados)' },
    { value: '42444', label: 'Mayoristas de aves de corral y productos avícolas' },
    { value: '42445', label: 'Mayoristas de productos de confitería' },
    { value: '42446', label: 'Mayoristas de pescado y mariscos' },
    { value: '42447', label: 'Mayoristas de carne y productos cárnicos' },
    { value: '42448', label: 'Mayoristas de frutas y verduras frescas' },
    { value: '42449', label: 'Mayoristas de otros productos alimenticios y relacionados' },
  ],

  [FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42451', label: 'Mayoristas de cereales y legumbres de campo' },
    { value: '42452', label: 'Mayoristas de ganado' },
    { value: '42459', label: 'Mayoristas de otras materias primas agrícolas' },
  ],

  [CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42461', label: 'Mayoristas de materiales plásticos y formas básicas de plástico' },
    { value: '42469', label: 'Mayoristas de otros productos químicos y relacionados' },
  ],

  [PETROLEUM_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42471', label: 'Terminales y estaciones de distribución de combustibles a granel' },
    {
      value: '42472',
      label:
        'Mayoristas de petróleo y productos derivados del petróleo (excepto terminales y estaciones de distribución a granel)',
    },
  ],

  [BEER_WINE_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42481', label: 'Mayoristas de cerveza y ale' },
    { value: '42482', label: 'Mayoristas de vino y bebidas alcohólicas destiladas' },
  ],

  [MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP]: [
    { value: '42491', label: 'Mayoristas de suministros agrícolas' },
    { value: '42492', label: 'Mayoristas de libros, revistas y periódicos' },
    { value: '42493', label: 'Mayoristas de flores, plantas de vivero y suministros para floristerías' },
    { value: '42494', label: 'Mayoristas de productos de tabaco y cigarrillos electrónicos' },
    { value: '42495', label: 'Mayoristas de pinturas, barnices y suministros relacionados' },
    { value: '42499', label: 'Mayoristas de otros bienes no duraderos diversos' },
  ],

  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],

  [AUTO_DEALERS_INDUSTRY_GROUP]: [
    { value: '44111', label: 'Concesionarios de automóviles nuevos' },
    { value: '44112', label: 'Concesionarios de automóviles usados' },
  ],

  [OTHER_MOTOR_DEALERS_INDUSTRY_GROUP]: [
    { value: '44121', label: 'Concesionarios de vehículos recreativos' },
    { value: '441222', label: 'Concesionarios de embarcaciones' },
    {
      value: '441227',
      label: 'Concesionarios de motocicletas, vehículos todoterreno (ATV) y otros vehículos de motor',
    },
  ],

  [AUTOMOTIVE_PARTS_INDUSTRY_GROUP]: [
    { value: '44133', label: 'Minoristas de repuestos y accesorios para vehículos de motor' },
    { value: '44134', label: 'Minoristas de neumáticos' },
  ],

  [BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP]: [
    { value: '44411', label: 'Centros de mejoras para el hogar' },
    { value: '44412', label: 'Minoristas de pintura y papel pintado' },
    { value: '44414', label: 'Minoristas de ferretería' },
    { value: '44418', label: 'Minoristas de otros materiales de construcción' },
  ],

  [LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP]: [
    { value: '44423', label: 'Minoristas de equipos motorizados para exteriores' },
    { value: '44424', label: 'Viveros, centros de jardinería y tiendas de suministros agrícolas' },
  ],

  [GROCERY_RETAILERS_INDUSTRY_GROUP]: [
    {
      value: '44511',
      label: 'Supermercados y otros comercios minoristas de alimentación (excepto tiendas de conveniencia)',
    },
    { value: '445131', label: 'Tiendas de conveniencia' },
    { value: '445132', label: 'Operadores de máquinas expendedoras' },
  ],

  [SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44523', label: 'Minoristas de frutas y verduras' },
    { value: '44524', label: 'Minoristas de carne' },
    { value: '44525', label: 'Minoristas de pescado y mariscos' },
    { value: '445291', label: 'Minoristas de productos de panadería' },
    { value: '445292', label: 'Minoristas de confitería y frutos secos' },
    { value: '445298', label: 'Otros comercios minoristas especializados en alimentación' },
  ],

  [BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP]: [],

  [FURNITURE_RETAILERS_INDUSTRY_GROUP]: [
    { value: '44911', label: 'Minoristas de muebles' },
    { value: '449121', label: 'Minoristas de revestimientos para suelos' },
    { value: '449122', label: 'Minoristas de tratamientos para ventanas' },
    { value: '449129', label: 'Minoristas de otros artículos para el hogar' },
  ],

  [ELECTRONICS_RETAILERS_INDUSTRY_GROUP]: [],

  [DEPARTMENT_STORE_INDUSTRY_GROUP]: [],

  [WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP]: [
    { value: '455211', label: 'Clubes de compras al por mayor e hipermercados' },
    { value: '455219', label: 'Otros comercios minoristas de mercancías generales' },
  ],

  [HEALTH_RETAILERS_SUB_SECTOR]: [
    { value: '45611', label: 'Farmacias y parafarmacias' },
    { value: '45612', label: 'Minoristas de cosméticos, productos de belleza y perfumes' },
    { value: '45613', label: 'Minoristas de productos ópticos' },
    { value: '456191', label: 'Minoristas de suplementos alimenticios y de salud' },
    { value: '456199', label: 'Otros comercios minoristas de salud y cuidado personal' },
  ],

  [GASOLINE_STATIONS_INDUSTRY_GROUP]: [
    { value: '45711', label: 'Gasolineras con tiendas de conveniencia' },
    { value: '45712', label: 'Otras gasolineras' },
  ],
  [FUEL_DEALERS_INDUSTRY_GROUP]: [],
  [CLOTHING_RETAILERS_INDUSTRY_GROUP]: [],
  [SHOE_RETAILERS_INDUSTRY_GROUP]: [],
  [JEWELRY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45831', label: 'Minoristas de joyería' },
    { value: '45832', label: 'Minoristas de equipaje y artículos de cuero' },
  ],
  [SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45911', label: 'Minoristas de artículos deportivos' },
    { value: '45912', label: 'Minoristas de artículos de hobby, juguetes y juegos' },
    { value: '45913', label: 'Minoristas de costura, labores de aguja y telas por pieza' },
    { value: '45914', label: 'Minoristas de instrumentos musicales y suministros' },
  ],
  [BOOK_RETAILERS_INDUSTRY_GROUP]: [],
  [FLORISTS_INDUSTRY_GROUP]: [],
  [OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP]: [
    { value: '45941', label: 'Minoristas de suministros de oficina y papelería' },
    { value: '45942', label: 'Minoristas de regalos, novedades y recuerdos' },
  ],
  [USED_MERCHANDISE_INDUSTRY_GROUP]: [],
  [OTHER_MISCELLANEOUS_INDUSTRY_GROUP]: [
    { value: '45991', label: 'Minoristas de mascotas y suministros para mascotas' },
    { value: '45992', label: 'Marchantes de arte' },
    { value: '45993', label: 'Concesionarios de viviendas prefabricadas (móviles)' },
    { value: '45999', label: 'Otros minoristas diversos' },
    { value: '459991', label: 'Minoristas de tabaco, cigarrillos electrónicos y otros suministros para fumar' },
  ],
  [SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '481111', label: 'Transporte aéreo regular de pasajeros' },
    { value: '481112', label: 'Transporte aéreo regular de carga' },
  ],
  [NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '481211', label: 'Transporte aéreo chárter no regular de pasajeros' },
    { value: '481212', label: 'Transporte aéreo chárter no regular de carga' },
    { value: '481219', label: 'Otro transporte aéreo no regular' },
  ],
  [DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483111', label: 'Transporte de carga en alta mar' },
    { value: '483112', label: 'Transporte de pasajeros en alta mar' },
    { value: '483113', label: 'Transporte de carga costero y por los Grandes Lagos' },
    { value: '483114', label: 'Transporte de pasajeros costero y por los Grandes Lagos' },
  ],
  [INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '483211', label: 'Transporte de carga por vías navegables interiores' },
    { value: '483212', label: 'Transporte de pasajeros por vías navegables interiores' },
  ],
  [GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    { value: '48411', label: 'Transporte general de carga por camión, local' },
    { value: '484121', label: 'Transporte general de carga por camión, larga distancia, carga completa' },
    { value: '484122', label: 'Transporte general de carga por camión, larga distancia, carga parcial' },
  ],
  [SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP]: [
    { value: '48421', label: 'Mudanza de bienes usados del hogar y oficina' },
    { value: '48422', label: 'Transporte especializado de carga (excepto bienes usados) por camión, local' },
    { value: '48423', label: 'Transporte especializado de carga (excepto bienes usados) por camión, larga distancia' },
  ],
  [URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP]: [
    { value: '485111', label: 'Sistemas de transporte urbano multimodal' },
    { value: '485112', label: 'Sistemas ferroviarios de cercanías' },
    { value: '485113', label: 'Sistemas de transporte en autobús y otros vehículos de motor' },
    { value: '485119', label: 'Otros sistemas de transporte urbano' },
  ],
  [INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP]: [],

  [TAXI_SERVICE_INDUSTRY_GROUP]: [
    { value: '48531', label: 'Servicios de taxi y viajes compartidos' },
    { value: '48532', label: 'Servicio de limusinas' },
  ],

  [SCHOOL_TRANSPORTATION_INDUSTRY_GROUP]: [],

  [CHARTER_BUS_INDUSTRY_GROUP]: [],

  [OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '485991', label: 'Transporte para personas con necesidades especiales' },
    { value: '485999', label: 'Todos los demás servicios de transporte terrestre de pasajeros' },
  ],

  [CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],

  [NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [],

  [OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48691', label: 'Transporte por tuberías de productos refinados del petróleo' },
    { value: '48699', label: 'Todo otro transporte por tuberías' },
  ],

  [SCENIC_LAND_INDUSTRY_GROUP]: [],

  [SCENIC_WATER_INDUSTRY_GROUP]: [],

  [SCENIC_OTHER_INDUSTRY_GROUP]: [],

  [SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48811', label: 'Operaciones aeroportuarias' },
    { value: '488111', label: 'Control del tráfico aéreo' },
    { value: '488119', label: 'Otras operaciones aeroportuarias' },
    { value: '48819', label: 'Otras actividades de apoyo al transporte aéreo' },
  ],

  [SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP]: [],

  [SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48831', label: 'Operaciones portuarias y de puertos' },
    { value: '48832', label: 'Manipulación de carga marítima' },
    { value: '48833', label: 'Servicios de navegación marítima' },
    { value: '48839', label: 'Otras actividades de apoyo al transporte acuático' },
  ],

  [SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '48841', label: 'Remolque de vehículos de motor' },
    { value: '48849', label: 'Otras actividades de apoyo al transporte por carretera' },
  ],

  [FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP]: [],

  [OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP]: [
    { value: '488991', label: 'Empaque y embalaje' },
    { value: '488999', label: 'Todas las demás actividades de apoyo al transporte' },
  ],

  [COURIER_DELIVERY_INDUSTRY_GROUP]: [],

  [LOCAL_DELIVERY_INDUSTRY_GROUP]: [],

  [MOTION_PICTURE_INDUSTRY_GROUP]: [
    { value: '51211', label: 'Producción de películas cinematográficas y videos' },
    { value: '51212', label: 'Distribución de películas cinematográficas y videos' },
    { value: '51213', label: 'Exhibición de películas cinematográficas y videos' },
    { value: '51219', label: 'Servicios de posproducción y otras industrias de películas cinematográficas y video' },
    { value: '512191', label: 'Teleproducción y otros servicios de posproducción' },
    { value: '512199', label: 'Otras industrias de películas cinematográficas y video' },
  ],

  [SOUND_INDUSTRY_GROUP]: [
    { value: '51223', label: 'Editoriales musicales' },
    { value: '51224', label: 'Estudios de grabación de sonido' },
    { value: '51225', label: 'Producción y distribución de grabaciones' },
    { value: '51229', label: 'Otras industrias de grabación de sonido' },
  ],

  [NEWSPAPER_INDUSTRY_GROUP]: [
    { value: '51311', label: 'Editoriales de periódicos' },
    { value: '51312', label: 'Editoriales de revistas' },
    { value: '51313', label: 'Editoriales de libros' },
    { value: '51314', label: 'Editoriales de directorios y listas de correo' },
    { value: '513191', label: 'Editoriales de tarjetas de felicitación' },
    { value: '513199', label: 'Todas las demás editoriales' },
  ],

  [SOFTWARE_PUBLISHERS_INDUSTRY_GROUP]: [],

  [RADIO_AND_TELEVISION_INDUSTRY_GROUP]: [
    { value: '51611', label: 'Emisoras de radio' },
    { value: '51612', label: 'Emisoras de televisión' },
  ],

  [MEDIA_STREAMING_INDUSTRY_GROUP]: [],

  [WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [
    { value: '517111', label: 'Operadores de telecomunicaciones por cable' },
    { value: '517112', label: 'Operadores de telecomunicaciones inalámbricas (excepto satélite)' },
    { value: '517121', label: 'Revendedores de servicios de telecomunicaciones' },
    { value: '517122', label: 'Agentes de servicios de telecomunicaciones inalámbricas' },
  ],

  [SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],

  [OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP]: [],

  [DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52211', label: 'Banca comercial' },
    { value: '52213', label: 'Cooperativas de crédito' },
    { value: '52218', label: 'Cajas de ahorro y otras instituciones de intermediación crediticia de depósito' },
  ],

  [NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52221', label: 'Emisión de tarjetas de crédito' },
    { value: '52222', label: 'Financiación de ventas' },
    { value: '522291', label: 'Préstamos al consumo' },
    { value: '522292', label: 'Crédito inmobiliario' },
    {
      value: '522299',
      label:
        'Intermediación crediticia internacional, del mercado secundario y toda otra intermediación crediticia no depositaria',
    },
  ],
  [ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP]: [
    { value: '52231', label: 'Corredores de préstamos hipotecarios y no hipotecarios' },
    {
      value: '52232',
      label: 'Procesamiento de transacciones financieras, actividades de reservas y cámaras de compensación',
    },
    { value: '52239', label: 'Otras actividades relacionadas con la intermediación crediticia' },
  ],

  [COMMODITY_CONTRACTS_INDUSTRY_GROUP]: [
    { value: '52315', label: 'Banca de inversión e intermediación de valores' },
    { value: '52316', label: 'Intermediación de contratos de materias primas' },
  ],

  [COMMODITY_EXCHANGES_INDUSTRY_GROUP]: [],

  [OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP]: [
    { value: '52391', label: 'Intermediación financiera diversa' },
    { value: '52394', label: 'Gestión de carteras y asesoramiento en inversiones' },
    { value: '523991', label: 'Actividades fiduciarias, de custodia y administración de fideicomisos' },
    { value: '523999', label: 'Otras actividades de inversión financiera diversas' },
  ],

  [INSURANCE_CARRIER_INDUSTRY_GROUP]: [
    { value: '52411', label: 'Compañías de seguros directos de vida, salud y asistencia médica' },
    { value: '524126', label: 'Compañías de seguros directos de bienes y accidentes' },
    { value: '524127', label: 'Compañías de seguros directos de títulos' },
    { value: '524128', label: 'Otras compañías de seguros directos (excepto vida, salud y asistencia médica)' },
    { value: '52413', label: 'Compañías de reaseguros' },
  ],

  [AGENCIES_BROKERAGES_INDUSTRY_GROUP]: [
    { value: '52421', label: 'Agencias y corredurías de seguros' },
    { value: '524291', label: 'Ajuste de reclamaciones' },
    {
      value: '524292',
      label:
        'Administración de beneficios farmacéuticos y otras actividades de administración externa de fondos de seguros y pensiones',
    },
    { value: '524298', label: 'Todas las demás actividades relacionadas con seguros' },
  ],

  [INSURANCE_FUNDS_INDUSTRY_GROUP]: [
    { value: '52511', label: 'Fondos de pensiones' },
    { value: '52512', label: 'Fondos de salud y bienestar' },
    { value: '52519', label: 'Otros fondos de seguros' },
  ],

  [OTHER_FUNDS_FUNDS_INDUSTRY_GROUP]: [
    { value: '52591', label: 'Fondos de inversión abiertos' },
    { value: '52592', label: 'Fideicomisos, patrimonios y cuentas de agencia' },
    { value: '52599', label: 'Otros vehículos financieros' },
  ],

  [LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP]: [
    { value: '53111', label: 'Arrendadores de edificios y viviendas residenciales' },
    { value: '53112', label: 'Arrendadores de edificios no residenciales (excepto mini almacenes)' },
    { value: '53113', label: 'Arrendadores de mini almacenes y unidades de autoalmacenamiento' },
    { value: '53119', label: 'Arrendadores de otros bienes inmuebles' },
  ],

  [OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP]: [],

  [ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP]: [
    { value: '53131', label: 'Administradores de propiedades inmobiliarias' },
    { value: '53132', label: 'Oficinas de tasadores de bienes inmuebles' },
    { value: '53139', label: 'Otras actividades relacionadas con bienes inmuebles' },
  ],

  [AUTOMOTIVE_LEASING_INDUSTRY_GROUP]: [
    { value: '53211', label: 'Alquiler y arrendamiento de automóviles de pasajeros' },
    {
      value: '53212',
      label: 'Alquiler y arrendamiento de camiones, remolques utilitarios y vehículos recreativos (RV)',
    },
  ],

  [CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP]: [
    { value: '53221', label: 'Alquiler de productos electrónicos de consumo y electrodomésticos' },
    { value: '532281', label: 'Alquiler de ropa de etiqueta y disfraces' },
    { value: '532282', label: 'Alquiler de cintas y discos de video' },
    { value: '532283', label: 'Alquiler de equipos de atención médica domiciliaria' },
    { value: '532284', label: 'Alquiler de artículos recreativos' },
    { value: '532289', label: 'Todo otro alquiler de bienes de consumo' },
  ],

  [GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP]: [],

  [COMMERCIAL_MACHINERY_INDUSTRY_GROUP]: [
    {
      value: '532411',
      label: 'Alquiler y arrendamiento de equipos comerciales de transporte aéreo, ferroviario y acuático',
    },
    {
      value: '532412',
      label: 'Alquiler y arrendamiento de maquinaria y equipos para construcción, minería y silvicultura',
    },
    { value: '53242', label: 'Alquiler y arrendamiento de maquinaria y equipos de oficina' },
    { value: '53249', label: 'Alquiler y arrendamiento de otra maquinaria y equipo comercial e industrial' },
  ],
  [LEGAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54111', label: 'Despachos de abogados' },
    { value: '54112', label: 'Despachos de notarios' },
    { value: '541191', label: 'Oficinas de búsqueda de títulos y cierre de operaciones inmobiliarias' },
    { value: '541199', label: 'Todos los demás servicios jurídicos' },
  ],

  [ACCOUNTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541211', label: 'Despachos de contadores públicos certificados (CPA)' },
    { value: '541213', label: 'Servicios de preparación de impuestos' },
    { value: '541214', label: 'Servicios de gestión de nóminas' },
    { value: '541219', label: 'Otros servicios contables' },
  ],

  [ARCHITECTURAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54131', label: 'Servicios de arquitectura' },
    { value: '54132', label: 'Servicios de arquitectura paisajística' },
    { value: '54133', label: 'Servicios de ingeniería' },
    { value: '54134', label: 'Servicios de delineación' },
    { value: '54135', label: 'Servicios de inspección de edificios' },
    { value: '54136', label: 'Servicios de estudios geofísicos y cartografía' },
    { value: '54137', label: 'Servicios de topografía y cartografía (excepto geofísica)' },
    { value: '54138', label: 'Laboratorios y servicios de ensayo' },
  ],

  [DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '54141', label: 'Servicios de diseño de interiores' },
    { value: '54142', label: 'Servicios de diseño industrial' },
    { value: '54143', label: 'Servicios de diseño gráfico' },
    { value: '54149', label: 'Otros servicios especializados de diseño' },
  ],

  [COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP]: [
    { value: '541511', label: 'Servicios de programación informática a medida' },
    { value: '541512', label: 'Servicios de diseño de sistemas informáticos' },
    { value: '541513', label: 'Servicios de administración de instalaciones informáticas' },
    { value: '541519', label: 'Otros servicios relacionados con la informática' },
  ],

  [TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP]: [
    { value: '541611', label: 'Servicios de consultoría en gestión administrativa y dirección general' },
    { value: '541612', label: 'Servicios de consultoría en recursos humanos' },
    { value: '541613', label: 'Servicios de consultoría en marketing' },
    { value: '541614', label: 'Servicios de consultoría en procesos, distribución física y logística' },
    { value: '541618', label: 'Otros servicios de consultoría en gestión' },
    { value: '54162', label: 'Servicios de consultoría ambiental' },
    { value: '54169', label: 'Otros servicios de consultoría científica y técnica' },
  ],

  [SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP]: [
    { value: '541713', label: 'Investigación y desarrollo en nanotecnología' },
    { value: '541714', label: 'Investigación y desarrollo en biotecnología (excepto nanobiotecnología)' },
    {
      value: '541715',
      label:
        'Investigación y desarrollo en ciencias físicas, ingeniería y ciencias de la vida (excepto nanotecnología y biotecnología)',
    },
    { value: '54172', label: 'Investigación y desarrollo en ciencias sociales y humanidades' },
  ],

  [ADVERTISING_SERVICES_INDUSTRY_GROUP]: [
    { value: '54181', label: 'Agencias de publicidad' },
    { value: '54182', label: 'Agencias de relaciones públicas' },
    { value: '54183', label: 'Agencias de compra de medios' },
    { value: '54184', label: 'Representantes de medios' },
    { value: '54185', label: 'Publicidad en interiores y exteriores' },
    { value: '54186', label: 'Publicidad por correo directo' },
    { value: '54187', label: 'Servicios de distribución de material publicitario' },
    { value: '54189', label: 'Otros servicios relacionados con la publicidad' },
  ],

  [OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '54191', label: 'Investigación de mercados y estudios de opinión pública' },
    { value: '54192', label: 'Servicios fotográficos' },
    { value: '54193', label: 'Servicios de traducción e interpretación' },
    { value: '54194', label: 'Servicios veterinarios' },
    { value: '54199', label: 'Todos los demás servicios profesionales, científicos y técnicos' },
  ],

  [OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP]: [],

  [FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],

  [EMPLOYMENTS_SERVICES_INDUSTRY_GROUP]: [
    { value: '561311', label: 'Agencias de colocación de empleo' },
    { value: '561312', label: 'Servicios de búsqueda de ejecutivos' },
    { value: '56132', label: 'Servicios de trabajo temporal' },
    { value: '56133', label: 'Organizaciones profesionales de empleadores' },
  ],

  [BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56141', label: 'Servicios de preparación de documentos' },
    { value: '56142', label: 'Centros de atención telefónica' },
    { value: '56143', label: 'Centros de servicios empresariales' },
    { value: '561431', label: 'Centros privados de correo' },
    { value: '561439', label: 'Otros centros de servicios empresariales (incluidos centros de copiado)' },
    { value: '56144', label: 'Agencias de cobro' },
    { value: '56145', label: 'Agencias de información crediticia' },
    { value: '561491', label: 'Servicios de recuperación de bienes' },
    { value: '561492', label: 'Servicios de taquigrafía e informes judiciales' },
    { value: '561499', label: 'Todos los demás servicios de apoyo empresarial' },
  ],
  [RESERVATION_SERVICES_INDUSTRY_GROUP]: [
    { value: '56151', label: 'Agencias de viajes' },
    { value: '56152', label: 'Operadores turísticos' },
    { value: '56159', label: 'Otros servicios de organización de viajes y reservas' },
  ],

  [INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP]: [
    { value: '561611', label: 'Servicios de investigación y verificación de antecedentes personales' },
    { value: '561612', label: 'Servicios de guardias de seguridad y patrullaje' },
    { value: '561613', label: 'Servicios de transporte blindado de valores' },
    { value: '56162', label: 'Servicios de sistemas de seguridad' },
  ],

  [SERVICES_TO_BUILDINGS_INDUSTRY_GROUP]: [
    { value: '56171', label: 'Servicios de exterminio y control de plagas' },
    { value: '56172', label: 'Servicios de limpieza' },
    { value: '56173', label: 'Servicios de jardinería y paisajismo' },
    { value: '56174', label: 'Servicios de limpieza de alfombras y tapicería' },
    { value: '56179', label: 'Otros servicios para edificios y viviendas' },
  ],

  [OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP]: [
    { value: '56191', label: 'Servicios de embalaje y etiquetado' },
    { value: '56192', label: 'Organizadores de convenciones y ferias comerciales' },
    { value: '56199', label: 'Todos los demás servicios de apoyo' },
  ],

  [WASTE_COLLECTION_INDUSTRY_GROUP]: [
    { value: '562111', label: 'Recolección de residuos sólidos' },
    { value: '562112', label: 'Recolección de residuos peligrosos' },
    { value: '562119', label: 'Otros servicios de recolección de residuos' },
  ],

  [WASTE_DISPOSAL_INDUSTRY_GROUP]: [
    { value: '562211', label: 'Tratamiento y eliminación de residuos peligrosos' },
    { value: '562212', label: 'Vertederos de residuos sólidos' },
    { value: '562213', label: 'Incineradores y plantas de combustión de residuos sólidos' },
    { value: '562219', label: 'Otros servicios de tratamiento y eliminación de residuos no peligrosos' },
  ],

  [REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP]: [
    { value: '56291', label: 'Servicios de remediación' },
    { value: '56292', label: 'Instalaciones de recuperación de materiales' },
    { value: '56299', label: 'Todos los demás servicios de gestión de residuos' },
    { value: '562991', label: 'Servicios de fosas sépticas y servicios relacionados' },
    { value: '562998', label: 'Todos los demás servicios diversos de gestión de residuos' },
  ],

  [ELEMENTARY_SCHOOLS_INDUSTRY_GROUP]: [],

  [JUNIOR_COLLEGES_INDUSTRY_GROUP]: [],

  [PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP]: [],

  [BUSINESS_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Escuelas de negocios y secretariado' },
    { value: '61142', label: 'Formación en informática' },
    { value: '61143', label: 'Formación en desarrollo profesional y dirección empresarial' },
  ],

  [TRADE_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '611511', label: 'Escuelas de cosmetología y barbería' },
    { value: '611512', label: 'Formación de vuelo' },
    { value: '611513', label: 'Programas de aprendizaje' },
    { value: '611519', label: 'Otras escuelas técnicas y de oficios' },
  ],

  [OTHER_SCHOOLS_INDUSTRY_GROUP]: [
    { value: '61161', label: 'Escuelas de bellas artes' },
    { value: '61162', label: 'Enseñanza deportiva y recreativa' },
    { value: '61163', label: 'Escuelas de idiomas' },
    { value: '61169', label: 'Todas las demás escuelas y programas de enseñanza' },
    { value: '611691', label: 'Preparación para exámenes y tutorías' },
    { value: '611692', label: 'Autoescuelas' },
    { value: '611699', label: 'Todas las demás escuelas y programas de enseñanza diversos' },
  ],

  [EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP]: [],
  [PHYSICIANS_INDUSTRY_GROUP]: [
    { value: '621111', label: 'Consultorios de médicos (excepto especialistas en salud mental)' },
    { value: '621112', label: 'Consultorios de médicos especialistas en salud mental' },
  ],

  [DENTISTS_INDUSTRY_GROUP]: [],

  [OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP]: [
    { value: '62131', label: 'Consultorios de quiroprácticos' },
    { value: '62132', label: 'Consultorios de optometristas' },
    { value: '62133', label: 'Consultorios de profesionales de salud mental (excepto médicos)' },
    {
      value: '62134',
      label: 'Consultorios de fisioterapeutas, terapeutas ocupacionales, terapeutas del habla y audiólogos',
    },
    { value: '621391', label: 'Consultorios de podólogos' },
    { value: '621399', label: 'Consultorios de otros profesionales de la salud diversos' },
  ],

  [OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP]: [
    { value: '61141', label: 'Centros de planificación familiar' },
    { value: '61142', label: 'Centros ambulatorios de salud mental y tratamiento del abuso de sustancias' },
    { value: '61149', label: 'Otros centros de atención ambulatoria' },
  ],

  [MEDICAL_LABS_INDUSTRY_GROUP]: [
    { value: '621511', label: 'Laboratorios médicos' },
    { value: '621512', label: 'Centros de diagnóstico por imagen' },
  ],

  [HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP]: [],

  [OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP]: [
    { value: '62191', label: 'Servicios de ambulancia' },
    { value: '621991', label: 'Bancos de sangre y órganos' },
    { value: '621999', label: 'Todos los demás servicios ambulatorios de atención médica diversos' },
  ],

  [GENERAL_MEDICAL_INDUSTRY_GROUP]: [],

  [SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP]: [],

  [SPECIALTY_HOSPITALS__INDUSTRY_GROUP]: [],

  [NURSING_CARE_FACILITIES_INDUSTRY_GROUP]: [],

  [RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP]: [
    { value: '62321', label: 'Centros residenciales para personas con discapacidad intelectual y del desarrollo' },
    { value: '62322', label: 'Centros residenciales de salud mental y tratamiento del abuso de sustancias' },
  ],

  [RETIREMENT_COMMUNITIES_INDUSTRY_GROUP]: [
    { value: '623311', label: 'Centros de atención continua para personas mayores jubiladas' },
    { value: '623312', label: 'Residencias asistidas para personas mayores' },
  ],

  [OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP]: [],

  [INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP]: [
    { value: '62411', label: 'Servicios para niños y jóvenes' },
    { value: '62412', label: 'Servicios para personas mayores y personas con discapacidad' },
    { value: '62419', label: 'Otros servicios individuales y familiares' },
  ],

  [OTHER_RELIEF_SERVICES_INDUSTRY_GROUP]: [
    { value: '62421', label: 'Servicios comunitarios de alimentación' },
    { value: '62422', label: 'Servicios comunitarios de vivienda' },
    { value: '62423', label: 'Servicios de emergencia y otros servicios de asistencia' },
  ],

  [VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP]: [],

  [CHILD_CARE_SERVICES_INDUSTRY_GROUP]: [],

  [PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP]: [
    { value: '71111', label: 'Compañías de teatro y teatros con cena' },
    { value: '71112', label: 'Compañías de danza' },
    { value: '71113', label: 'Grupos musicales y artistas' },
    { value: '71119', label: 'Otras compañías de artes escénicas' },
  ],

  [SPECTATOR_SPORTS_INDUSTRY_GROUP]: [
    { value: '711211', label: 'Equipos y clubes deportivos' },
    { value: '711212', label: 'Hipódromos y circuitos de carreras' },
    { value: '711219', label: 'Otros deportes para espectadores' },
  ],

  [PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP]: [
    {
      value: '71131',
      label: 'Promotores de artes escénicas, deportes y eventos similares con instalaciones',
    },
    {
      value: '71132',
      label: 'Promotores de artes escénicas, deportes y eventos similares sin instalaciones',
    },
  ],

  [ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP]: [],

  [INDEPENDENT_ARTISTS_INDUSTRY_GROUP]: [],
  [AMUSEMENT_PARKS_INDUSTRY_GROUP]: [
    { value: '71311', label: 'Parques de atracciones y parques temáticos' },
    { value: '71312', label: 'Salones de juegos recreativos' },
  ],

  [GAMBLING_INDUSTRIES_INDUSTRY_GROUP]: [
    { value: '71321', label: 'Casinos (excepto hoteles casino)' },
    { value: '71329', label: 'Otras industrias del juego' },
  ],

  [OTHER_AMUSEMENT_INDUSTRY_GROUP]: [
    { value: '71391', label: 'Campos de golf y clubes de campo' },
    { value: '71392', label: 'Instalaciones para esquí' },
    { value: '71393', label: 'Puertos deportivos' },
    { value: '71394', label: 'Centros deportivos y recreativos' },
    { value: '71395', label: 'Centros de bolos' },
    { value: '71399', label: 'Todas las demás industrias de entretenimiento y recreación' },
  ],

  [TRAVELER_ACCOMMODATION_INDUSTRY_GROUP]: [
    { value: '72111', label: 'Hoteles (excepto hoteles casino) y moteles' },
    { value: '72112', label: 'Hoteles casino' },
    { value: '72119', label: 'Otros alojamientos para viajeros' },
    { value: '721191', label: 'Posadas tipo bed and breakfast' },
    { value: '721199', label: 'Todos los demás alojamientos para viajeros' },
  ],

  [RECREATIONAL_CAMPS_INDUSTRY_GROUP]: [
    { value: '721211', label: 'Parques para vehículos recreativos (RV) y campamentos' },
    { value: '721214', label: 'Campamentos recreativos y vacacionales (excepto campamentos para caravanas)' },
  ],

  [WORKERS_CAMPS_INDUSTRY_GROUP]: [],

  [SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP]: [
    { value: '72231', label: 'Contratistas de servicios de alimentación' },
    { value: '72232', label: 'Servicios de catering' },
    { value: '72233', label: 'Servicios móviles de comida' },
  ],

  [DRINKING_PLACES_INDUSTRY_GROUP]: [],

  [OTHER_EATING_PLACES_INDUSTRY_GROUP]: [
    { value: '722511', label: 'Restaurantes de servicio completo' },
    { value: '722513', label: 'Restaurantes de servicio limitado' },
    { value: '722514', label: 'Cafeterías, bufés grill y bufés' },
    { value: '722515', label: 'Bares de aperitivos y bebidas no alcohólicas' },
  ],

  [AUTOMOTIVE_REPAIR_INDUSTRY_GROUP]: [
    { value: '811111', label: 'Reparación general de automóviles' },
    { value: '811114', label: 'Reparación especializada de automóviles' },
    { value: '811121', label: 'Reparación y mantenimiento de carrocería, pintura e interiores de automóviles' },
    { value: '811122', label: 'Talleres de sustitución de cristales para automóviles' },
    { value: '811191', label: 'Centros de cambio de aceite y lubricación para automóviles' },
    { value: '811192', label: 'Lavaderos de automóviles' },
    { value: '811198', label: 'Todos los demás servicios de reparación y mantenimiento de automóviles' },
  ],

  [ELECTRONICS_REPAIR_INDUSTRY_GROUP]: [],

  [COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP]: [],

  [PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP]: [
    { value: '811411', label: 'Reparación y mantenimiento de equipos para el hogar y jardín' },
    { value: '811412', label: 'Reparación y mantenimiento de electrodomésticos' },
    { value: '81142', label: 'Retapizado y reparación de muebles' },
    { value: '81143', label: 'Reparación de calzado y artículos de cuero' },
    { value: '81149', label: 'Otros servicios de reparación y mantenimiento de bienes personales y del hogar' },
  ],

  [PERSONAL_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '812111', label: 'Barberías' },
    { value: '812112', label: 'Salones de belleza' },
    { value: '812113', label: 'Salones de manicura' },
    { value: '81219', label: 'Otros servicios de cuidado personal' },
    { value: '812191', label: 'Centros de dieta y reducción de peso' },
  ],

  [DEATH_CARE_SERVICES_INDUSTRY_GROUP]: [
    { value: '81221', label: 'Funerarias y servicios funerarios' },
    { value: '81222', label: 'Cementerios y crematorios' },
  ],
  [LAUNDRY_SERVICES_INDUSTRY_GROUP]: [
    { value: '81231', label: 'Lavanderías y tintorerías de autoservicio con monedas' },
    { value: '81232', label: 'Servicios de lavandería y tintorería (excepto de autoservicio con monedas)' },
    { value: '812331', label: 'Suministro de ropa blanca' },
    { value: '812332', label: 'Lavanderías industriales' },
  ],

  [OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP]: [
    { value: '81291', label: 'Servicios de cuidado de mascotas (excepto veterinarios)' },
    { value: '81292', label: 'Revelado fotográfico' },
    { value: '81293', label: 'Estacionamientos y garajes' },
    { value: '81299', label: 'Todos los demás servicios personales' },
  ],

  [RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP]: [],

  [GRANTMAKING_INDUSTRY_GROUP]: [
    { value: '813211', label: 'Fundaciones de concesión de subvenciones' },
    { value: '813212', label: 'Organizaciones voluntarias de salud' },
    { value: '813219', label: 'Otros servicios de concesión de subvenciones y donaciones' },
  ],

  [SOCIAL_ADVOCACY_INDUSTRY_GROUP]: [
    { value: '813311', label: 'Organizaciones de derechos humanos' },
    { value: '813312', label: 'Organizaciones de medio ambiente, conservación y protección de la vida silvestre' },
    { value: '813319', label: 'Otras organizaciones de defensa social' },
  ],

  [SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP]: [],

  [BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP]: [
    { value: '81391', label: 'Asociaciones empresariales' },
    { value: '81392', label: 'Organizaciones profesionales' },
    { value: '81393', label: 'Sindicatos y organizaciones laborales similares' },
    { value: '81394', label: 'Organizaciones políticas' },
    {
      value: '81399',
      label:
        'Otras organizaciones similares (excepto organizaciones empresariales, profesionales, laborales y políticas)',
    },
  ],

  [MANAGEMENT_OF_COMPANIES_SECTOR]: [
    { value: '551111', label: 'Oficinas de sociedades holding bancarias' },
    { value: '551112', label: 'Oficinas de otras sociedades holding' },
    { value: '551114', label: 'Oficinas corporativas, filiales y de gestión regional' },
  ],

  [RAIL_TRANSPORTATION_SUB_SECTOR]: [
    { value: '482111', label: 'Ferrocarriles de línea principal' },
    { value: '482112', label: 'Ferrocarriles de línea corta' },
  ],

  [POSTAL_SERVICE_SUB_SECTOR]: [],

  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [
    { value: '49311', label: 'Almacenamiento y depósito general' },
    { value: '49312', label: 'Almacenamiento y depósito refrigerado' },
    { value: '49313', label: 'Almacenamiento y depósito de productos agrícolas' },
    { value: '49319', label: 'Otros servicios de almacenamiento y depósito' },
  ],

  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],

  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [
    { value: '51921', label: 'Bibliotecas y archivos' },
    { value: '51929', label: 'Portales de búsqueda web y todos los demás servicios de información' },
  ],

  [MONETARY_BANK_SUB_SECTOR]: [],

  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],

  [MUSEUMS_SUB_SECTOR]: [
    { value: '71211', label: 'Museos' },
    { value: '71212', label: 'Sitios históricos' },
    { value: '71213', label: 'Zoológicos y jardines botánicos' },
    { value: '71219', label: 'Parques naturales y otras instituciones similares' },
  ],

  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [
    { value: '92111', label: 'Oficinas del Poder Ejecutivo' },
    { value: '92112', label: 'Órganos legislativos' },
    { value: '92113', label: 'Actividades de finanzas públicas' },
    { value: '92114', label: 'Oficinas combinadas de los poderes ejecutivo y legislativo' },
    { value: '92115', label: 'Gobiernos tribales de indígenas americanos y nativos de Alaska' },
    { value: '92119', label: 'Otros servicios generales de apoyo gubernamental' },
  ],

  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [
    { value: '92211', label: 'Tribunales' },
    { value: '92212', label: 'Servicios de policía' },
    { value: '92213', label: 'Asesoría jurídica y fiscalía' },
    { value: '92214', label: 'Instituciones penitenciarias' },
    { value: '92215', label: 'Oficinas de libertad condicional y de supervisión de probation' },
    { value: '92216', label: 'Servicios de protección contra incendios' },
    { value: '92219', label: 'Otras actividades de justicia, orden público y seguridad' },
  ],

  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [
    { value: '92311', label: 'Administración de programas educativos' },
    { value: '92312', label: 'Administración de programas de salud pública' },
    {
      value: '92313',
      label:
        'Administración de programas de recursos humanos (excepto programas de educación, salud pública y asuntos de veteranos)',
    },
    { value: '92314', label: 'Administración de asuntos de veteranos' },
  ],

  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [
    {
      value: '92411',
      label: 'Administración de programas de recursos del aire y del agua y de gestión de residuos sólidos',
    },
    { value: '92412', label: 'Administración de programas de conservación' },
  ],

  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [
    { value: '92511', label: 'Administración de programas de vivienda' },
    {
      value: '92512',
      label: 'Administración de planificación urbana y desarrollo comunitario y rural',
    },
  ],

  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [
    { value: '92611', label: 'Administración de programas económicos generales' },
    { value: '92612', label: 'Regulación y administración de programas de transporte' },
    {
      value: '92613',
      label: 'Regulación y administración de servicios de comunicaciones, electricidad, gas y otros servicios públicos',
    },
    { value: '92614', label: 'Regulación de la comercialización agrícola y de productos básicos' },
    {
      value: '92615',
      label: 'Regulación, concesión de licencias e inspección de diversos sectores comerciales',
    },
  ],

  [SPACE_RESEARCH_SUB_SECTOR]: [],

  [NATIONAL_SECURITY_SUB_SECTOR]: [
    { value: '92811', label: 'Seguridad nacional' },
    { value: '92812', label: 'Asuntos internacionales' },
  ],
};
